export class SendOtp {
  MobileNo: any;
  EmailId: any;
}